import { useEffect, useState } from "react"
import { parse } from "next-useragent"

export default function useBrowser() {
  const [browser, setBrowser] = useState({
    ua: {},
    os: "",
    name: "",
    isClient: false,
    inApp: false,
    hasTouch: false,
    isMobile: false
  })

  useEffect(() => {
    const ua = parse(window.navigator.userAgent)
    const os = ua.os.toLowerCase()
    const name = ua.browser.toLowerCase()

    setBrowser({
      ua,
      os,
      name,
      isClient: true,
      inApp: inAppBrowsers.includes(name),
      hasTouch: "ontouchstart" in window || navigator.msMaxTouchPoints > 0,
      isMobile:
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
          navigator.userAgent
        )
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return browser
}

const inAppBrowsers = [
  "discord",
  "facebook",
  "hangouts",
  "instagram",
  "kakaotalk",
  "kik",
  "line",
  "linkedin",
  "meet",
  "messenger",
  "musical_ly",
  "naver",
  "pinterest",
  "reddit",
  "signal",
  "skype",
  "slack",
  "snapchat",
  "teams",
  "telegram",
  "tiktok",
  "tumblr",
  "twitter",
  "viber",
  "webview",
  "wechat",
  "whatsapp",
  "zoom"
]
